import { AgGridReact } from 'ag-grid-react';
import React, { useState, useCallback, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  addDirtyProduct,
  fetchProductByTab,
  fetchS3ImagesForTab,
  updateProduct,
  selectAllProductData,
} from '../../productmanagement/slices/productsSlice';
import NumericCellEditor from '../../../../../common/components/grid/numericCellEditor';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import ProductEnabledCellRenderer from './ProductEnabledCellRenderer';
import _ from 'lodash';
import { EditOutlined } from '@ant-design/icons';
import { selectAll,  TAB_TYPE_ENUM } from '../slices/tabsSlice';
import { addTab, setActiveTab, createTab } from '../slices/tabsSlice';
import { fetchProduct, upsertProduct } from '../slices/tabProductsSlice';
import { fetchImagesInFolder } from '../slices/productImagesSlice';
import moment from 'moment';

function GridContainer({ setSelectedProduct }) {
  const products = useSelector(selectAllProductData);
  const tabs = useSelector(selectAll);
  const dispatch = useDispatch();
  const gridRef = useRef();

  const [columnDefs] = useState([
    {
      headerName: 'Enabled',
      field: 'enabled',
      sortable:true,
      width: 100,
      cellRenderer: ProductEnabledCellRenderer,
      cellStyle: { backgroundColor: 'lightyellow' },
    },
    {
      headerName: 'SKU',
      field: 'product_sku',
      width: 100,
      filter: 'agTextColumnFilter',
      filterParams: {
        buttons: ['reset', 'apply'],
      },
    },
    {
      headerName: 'Title',
      field: 'product_title',
      resizable: true,
      width: 300,
      filter: 'agTextColumnFilter',
      filterParams: {
        buttons: ['reset', 'apply'],
      },
    },
    {
      headerName: 'Stock',
      field: 'stock',
      editable: true,
      sortable:true,
      cellStyle: { backgroundColor: 'lightyellow' },
    },
    {
      headerName: 'Price ($)',
      field: 'offer_data.AUD.price',
      editable: true,
      sortable:true,
      cellStyle: { backgroundColor: 'lightyellow' },
    },
    {
      headerName: 'KFP ($)',
      field: 'offer_data.AUD.kogan_first_price',
      editable: true,
      cellStyle: { backgroundColor: 'lightyellow' },
    },
    {
      headerName: 'RRP ($)',
      field: 'offer_data.AUD.rrp',
      editable: true,
      cellStyle: { backgroundColor: 'lightyellow' },
    },
    {
      headerName: 'HT (Days)',
      field: 'offer_data.AUD.handling_days',
      editable: true,
      sortable:true,
      cellStyle: { backgroundColor: 'lightyellow' },
    },
    {
      headerName: 'Ship ($)',
      field: 'offer_data.AUD.shipping',
      editable: true,
      sortable:true,
      cellStyle: { backgroundColor: 'lightyellow' },
    },
    {
      headerName: 'GTIN',
      field: 'product_gtin',
      resizable: true,
      width: 130,
      filter: 'agTextColumnFilter',
      filterParams: {
        buttons: ['reset', 'apply'],
      },
    },
    {
      headerName: 'Brand',
      field: 'brand',
      resizable: true,
      width: 200,
      filter: 'agTextColumnFilter',
      filterParams: {
        buttons: ['reset', 'apply'],
      },
    },
    {
      headerName: 'Category',
      field: 'category',
      resizable: true,
      filter: 'agTextColumnFilter',
      filterParams: {
        buttons: ['reset', 'apply'],
      },
    },
    {
      headerName: 'Subtitle',
      field: 'product_subtitle',
      resizable: true,
      width: 200,
      filter: 'agTextColumnFilter',
      filterParams: {
        buttons: ['reset', 'apply'],
      },
    },
    {
      headerName: 'Created On',
      field: 'created',
      resizable: true,
      sortable:true,
      width: 200,
      filter: 'agDateColumnFilter',
      valueFormatter: (params) => {
        return moment(params.value).format('lll')
      }
    },
  ]);
  const defaultColDef = {
    resizable: true,
    width: 100,
  };

  const onCellDoubleClicked = (event) => {
    
    if (!event.colDef.editable) {
      const tab = createTab(event.data, TAB_TYPE_ENUM.EDIT, '');
      const existingTab = _.find(tabs, {key:tab.key});

      if(!existingTab){
        //create a copy of the grid product in the koganTabProduct slice
        dispatch(upsertProduct(event.data));
        //Update tabSlice
        dispatch(addTab(tab));
        dispatch(setActiveTab(tab));
        //Lazy load full product in the koganTabProduct slice
        dispatch(fetchProduct(event.data.product_sku));
        dispatch(fetchImagesInFolder(event.data.product_sku));
        //  dispatch(fetchS3ImagesForTab(tab))
      }else {
        dispatch(setActiveTab(existingTab));
      }
    }
  };
  const onCellEditRequest = (event) => {
    const product = _.cloneDeep(event.data);
    _.set(product, event.colDef.field, event.newValue);
    dispatch(updateProduct(product));
    dispatch(addDirtyProduct(product));
  };

  return (
    <div className="ag-theme-alpine" style={{ height: '100%', width: '100%' }}>
      <AgGridReact
        ref={gridRef}
        rowData={products}
        columnDefs={columnDefs}
        rowSelection={'single'}
        onCellDoubleClicked={onCellDoubleClicked}
        defaultColDef={defaultColDef}
        readOnlyEdit={true}
        onCellEditRequest={onCellEditRequest}
        rowBuffer={30}
        debounceVerticalScrollbar={true}
        pagination={true}
        paginationPageSize={12}
      ></AgGridReact>
    </div>
  );
}
export default GridContainer;
